import initialListState from 'store/hoReducers/paginatedList/initialState';
import {
  INTENTS_SORT_OPTIONS,
  INTENTS_FILTER_OPTIONS,
} from 'constants/intentsOptions';

const initialState = {
  ...initialListState,
  list: {
    ...initialListState.list,
    sortOptions: INTENTS_SORT_OPTIONS,
    filterOptions: INTENTS_FILTER_OPTIONS,
    filterParams: {},
    paginationOptions: {
      page: 1,
      size: 50,
      name__icontains: '',
      ordering: '-created_at',
      archived: '',
      imported_from_xpack: '',
    },
  },
  partialUpdate: {
    error: '',
    isLoading: false,
  },
  train: {
    error: '',
    isLoading: false,
  },
};

export default initialState;
